export default __webpack_public_path__ + "0674f39.png";